function normalizeConfiguredBaseUrl(value = '') {
  return value
    .trim()
    .replace(/^REACT_APP_API_BASE_URL\s*=\s*/i, '')
    .trim();
}

const configuredBaseUrl = normalizeConfiguredBaseUrl(process.env.REACT_APP_API_BASE_URL || '');

function getFallbackApiBaseUrl() {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }

  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname === '[::1]'
    || hostname === '::1';

  return isLocalhost ? 'http://localhost:3001' : '';
}

const API_BASE_URL = (configuredBaseUrl || getFallbackApiBaseUrl()).replace(/\/+$/, '');

export function buildApiUrl(path = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return API_BASE_URL ? `${API_BASE_URL}${normalizedPath}` : normalizedPath;
}

export { API_BASE_URL };
